module.exports = __webpack_public_path__ + "img/Support-skill-321.1aee423f.png";